import { useContext } from "react";
import { AppContext } from "../App";
import { MdGridView } from "react-icons/md";

export default function MainMenuBtn() {
  const appContext = useContext(AppContext);

  return (
    <button
      className="MainMenuBtn mMobileOnly"
      data-sidebar-open={appContext.isSideBarOpen}
      onClick={() => appContext.setIsSideBarOpen(true)}
      aria-label="Open mobile menu"
    >
      <MdGridView size={24} />
    </button>
  );
}
